module.exports = __webpack_public_path__ + "img/5.56c0f6c9.svg";